import React from 'react'
import { sendService, sendServiceAsync, openFile } from "../../Services/service";
import Landing from './../../landing/containers/LandingContainer';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './../../Actions/Dashboard';
import * as ModalActs from './../../Actions/Modal';

class DownloadExcel extends React.Component {
  state = {
    filterIep: '0',
    startDate: '',
    endDate: '',
    ieps: [],
    barrioFilter: [],
    barrio: '0',
    type: 0,
  }

  procedimientos = [
    { userId: 'Caracterizaciones', key: 'Caracterizaciones' },
    { userId: 'Censos', key: 'Censos' },
    { userId: 'Operativos', key: 'Operativos' },
    { userId: 'Publicidad', key: 'Publicidad' },
    { userId: 'Incautaciones', key: 'Incautaciones' },
  ]

  onHandlerChange = (key, val) => {
    this.setState({ [key]: val })
  }

  getXlsx = () => {
    if (this.state.type === 0) {
      alert('Favor ingresar el tipo de procedimiento para realizar la descarga.')
      return
    }

    this.props.modalActions.openLoader()
    let filter = []
    filter = this.state.type !== '' ? [`type=${this.state.type}`] : filter
    filter = this.state.filterIep !== '0' ? [...filter, `iep=${this.state.filterIep}`] : filter
    filter = this.state.startDate !== '' ? [...filter, `start=${this.state.startDate}`] : filter
    filter = this.state.endDate !== '' ? [...filter, `end=${this.state.endDate}`] : filter

    const url = `/api/v1/files/getxlsx?${filter.join('&')}`
    sendServiceAsync(url, "GET").then(value => {
      value.blob().then(file => {
        openFile(file, `${this.state.type}.xlsx`)
        this.props.modalActions.closeLoader()
        // this.setState({ filterIep: '0', startDate: '', endDate: '', type: 0 })
      }).catch(r => this.props.modalActions.closeLoader())
    })
  }

  getPdfs = () => {
    if (this.state.type === 0 || this.state.filterIep === '0' || this.state.startDate === '' || this.state.endDate === '') {
      alert('Favor ingresar el tipo de procedimiento, el funcionario, la fecha inicial y la fecha final para realizar la descarga.')
      return
    }
    this.props.modalActions.openLoader()
    let filter = []
    filter = this.state.type !== '' ? [`type=${this.state.type}`] : filter
    filter = this.state.filterIep !== '0' ? [...filter, `userId=${this.state.filterIep}`] : filter
    filter = this.state.startDate !== '' ? [...filter, `start=${this.state.startDate}`] : filter
    filter = this.state.endDate !== '' ? [...filter, `end=${this.state.endDate}`] : filter

    const url = `/api/v1/files/getPdfs?${filter.join('&')}`

    sendServiceAsync(url).then(value => {
      value.blob().then(file => {
        openFile(file, `${this.state.type}.zip`)
        this.props.modalActions.closeLoader()
        // this.setState({ filterIep: '0', startDate: '', endDate: '', type: 0 })
      }).catch(r => this.props.modalActions.closeLoader())
    })
  }

  selectInput(props) {
    return (
      <div className='line line-33'>
        <label>{props.label}</label>
        <div className="div-input-form">
          <select defaultValue={0} value={this.state[props.key]} onChange={(e) => props.onChangeFilter(props.key, e.target.value)} >
            <option value={0} disabled={true}>--</option>
            {
              props.keyRef.map(r => <option value={r.userId} key={r.userId}>{r.key}</option>)
            }
          </select>
        </div>
      </div>
    )
  }

  textInput(props) {
    return (
      <div className='line line-33'>
        <label>{props.label}</label>
        <div className="div-input-form">
          <input
            type={props.type ?? 'text'}
            value={this.state[props.key]}
            // disabled={!this.state.editable}
            onChange={(e) => props.onChangeFilter(props.key, e.target.value)}
          />
        </div>
      </div>
    )
  }

  componentDidMount() {
    sendService(`/api/v1/ep/getIep`, "GET").then(value => {
      console.log(value.response)
      if (value.status === 200)
        this.setState({ ieps: value.response })
    })
    // this.getkeyTexts('barrio')
  }

  render() {
    return (
      <Landing history={this.props.history} hasFooter={false}>
        <div className="content-line">
          <div>
            {this.selectInput({ key: 'type', label: 'Procedimiento', keyRef: this.procedimientos, onChangeFilter: this.onHandlerChange })}
            {this.selectInput({ key: 'filterIep', label: 'Funcionario de espacio público', keyRef: this.state.ieps, onChangeFilter: this.onHandlerChange })}
            {this.textInput({ key: 'startDate', label: 'Fecha inicial', type: 'date', onChangeFilter: this.onHandlerChange })}
            {this.textInput({ key: 'endDate', label: 'Fecha final', type: 'date', onChangeFilter: this.onHandlerChange })}
          </div>
          <div className='flex-center'>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div onClick={this.getPdfs} className='primary-background-color on-mouse-hover' style={{ color: 'white', fontSize: '20px', height: '48px', border: '1px solid gray', borderRadius: '7px', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0 8px', marginRight: '10px' }}>
                Descargar Pdf
                <i className="fas fa-file-pdf" style={{ marginLeft: '16px' }}></i>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div onClick={this.getXlsx} className='green-background-color on-mouse-hover' style={{ color: 'white', fontSize: '20px', height: '48px', border: '1px solid gray', borderRadius: '7px', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0 8px', marginRight: '10px' }}>
                Descargar Excel
                <i className="fas fa-file-excel" style={{ marginLeft: '16px' }}></i>
              </div>
            </div>
          </div>

        </div>
      </Landing>
    )
  }
}

function mapStateToProps(state) {
  return {
    session: state.session
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    modalActions: bindActionCreators(ModalActs, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DownloadExcel);